function blockAccordion() {
	document.querySelectorAll('.accordion-question').forEach((question) => {
		question.addEventListener('click', function () {
			let allAnswers = document.querySelectorAll('.accordion-answer');
			let allQuestions = document.querySelectorAll('.accordion-question');

			if (this.classList.contains('open')) {
				this.classList.remove('open');
				this.nextElementSibling.style.display = 'none';
			} else {
				allQuestions.forEach((q) => q.classList.remove('open'));
				allAnswers.forEach((a) => (a.style.display = 'none'));

				this.classList.add('open');
				this.nextElementSibling.style.display = 'block';
			}
		});
	});

	updateTabInputs();

	window.addEventListener('resize', updateTabInputs);
}

function updateTabInputs() {
	const isMobile = window.innerWidth < 1024;
	document.querySelectorAll('.single-product-tabs-wrapper input[id^="tab-"]').forEach(input => {
		if (isMobile) {
			if (input.type !== 'checkbox') {
				input.type = 'checkbox';
				input.removeAttribute('name');
			}
		} else {
			if (input.type !== 'radio') {
				input.type = 'radio';
				input.name = 'tabs';
			}
		}
	});
}

export {blockAccordion};